var map = {
	"./appcharts.vue": 44166,
	"./builderimages.vue": 16226,
	"./catalogservices.vue": 5513,
	"./configurations.vue": 12229,
	"./gitconfigs.vue": 41140,
	"./namespaces.vue": 60380,
	"./services.vue": 58624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9410;